export default __webpack_public_path__ + "static/media/icon-defrost.0718b400.svg";